<!-- components/LoginComponent.vue -->
<template>
    <div class="d-flex align-items-center justify-content-center vh-100 main">
      <div style="width: 25rem">
        <form @submit.prevent="login">
          <div class="form-floating mb-3">
            <input type="email" class="form-control" id="email" placeholder="Email" v-model="email">
            <label for="email">Email</label>
          </div>
          <div class="form-floating mb-3">
            <input type="password" class="form-control" id="password" placeholder="Password" v-model="password">
            <label for="password">Password</label>
          </div>
          <button type="submit" class="btn btn-primary btn-lg btn-block">Login</button>
        </form>
        <p v-if="error" class="error">{{ error }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        email: '',
        password: '',
        error: ''
      };
    },
    methods: {
      async login() {
        try {
          const credentials = { email: this.email, password: this.password };
          await this.$store.dispatch('admin/login', credentials);

          if (this.$store.getters['admin/isLoggedIn']) {
            this.$router.replace({ name: 'admin' });
          } else {
            this.error = 'Invalid email or password';
          }
        } catch (error) {
          
          this.error = 'An error occurred during login';
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .btm-block {
    width: 100vw !important;
  }
  main {
    font-size: 16px;
  }
  .error {
    color: var(--status-error);
    font-size: 1.5rem;
    font-weight: 700;
  }
  </style>

<style scoped>
.btm-block {
    width: 100vw !important;
}

main {
    font-size: 16px;
}

.error {
    color: var(--status-error);
    font-size: 1.5rem;
    font-weight: 700;
}
</style>